import styled, { css } from 'styled-components';
import { size } from '../../layout/helpers';
import { rotate } from '../../layout/keyframes';
import type { OperationsStateIconStates } from '.';

interface WrapperProps {
  $state: OperationsStateIconStates;
}

export const Wrapper = styled.div<WrapperProps>`
  font-size: ${size(3)};

  svg {
    display: block;
    fill: var(--_icon-fill, currentColor);
  }

  ${({ $state }) =>
    $state === 'completed'
      ? css`
          --_icon-fill: var(--c-semantic-success-500);
        `
      : $state === 'inProgress'
        ? css`
            --_icon-fill: var(--c-semantic-warning-500);

            svg {
              animation: ${rotate} 1s linear infinite
            }
          `
        : $state === 'problem'
          ? css`
            --_icon-fill: var(--c-semantic-error-500);
          `
          : css`
              --_icon-fill: var(--c-text-muted);
            `}
`;
